import { getCompanyFormClsx, getCompanyFormId } from "../helpers";

const id = "criteria";

export default function CompanyCriteria({
  heading,
  criteriaList,
}: {
  heading: string;
  criteriaList: string[];
}) {
  return (
    <aside
      id={getCompanyFormId(id)}
      className={getCompanyFormClsx("aside", id)}
    >
      <CompanyFieldsetSubHeading>{heading}</CompanyFieldsetSubHeading>

      <ul className={"texts__caption"}>
        {criteriaList.map((criteria) => (
          <li key={criteria}>{criteria}</li>
        ))}
      </ul>
    </aside>
  );
}

function CompanyFieldsetSubHeading({
  children,
}: {
  children: React.ReactNode;
}) {
  return <h2 className="texts__body_text--bold">{children}</h2>;
}
